/**
 * Chess Board Component (Inline Styles)
 * Default export - uses inline styles with grid
 */
import type { BoardProps } from "../../types";
import { Square } from "../square";
import { BoardBase } from "./BoardBase";

export function Board(props: BoardProps) {
  const containerStyle: React.CSSProperties = {
    display: "grid",
    gridTemplateColumns: "repeat(8, 64px)",
    border: "2px solid var(--cn-chess-board-frame)",
    boxShadow: "var(--chess-board-shadow)",
  };

  return (
    <BoardBase
      {...props}
      renderSquare={({
        file,
        rank,
        piece,
        isSelected,
        isLegalMove,
        isCapture,
        onClick,
      }) => (
        <Square
          key={`${file}${rank}`}
          file={file}
          rank={rank}
          piece={piece}
          isSelected={isSelected}
          isLegalMove={isLegalMove}
          isCapture={isCapture}
          onClick={onClick}
          isMyTurn={props.isMyTurn}
          gameEnded={props.gameEnded}
        />
      )}
      style={containerStyle}
    />
  );
}
